import React from 'react';

type Props = {
  percentage: number;
  isShowPercentageStr: boolean;
  isAchieved: boolean;
  backgroundColorTailwind: string;
  foregroundColorTailwind: string | null;
  borderColorTailwind?: string;
  classNames?: {
    background?: (defaultClassName: string) => string;
    foreground?: (defaultClassName: string) => string;
    percentageStr?: (defaultClassName: string) => string;
    percentageUnitStr?: (defaultClassName: string) => string;
  };
};

const identity = <T,>(s: T): T => s;

export const Percentage = ({
  backgroundColorTailwind,
  foregroundColorTailwind,
  percentage,
  isShowPercentageStr,
  isAchieved,
  borderColorTailwind,
  classNames,
}: Props): React.ReactElement => {
  const { background, foreground, percentageStr, percentageUnitStr } = {
    background: classNames?.background ?? identity,
    foreground: classNames?.foreground ?? identity,
    percentageStr: classNames?.percentageStr ?? identity,
    percentageUnitStr: classNames?.percentageUnitStr ?? identity,
  };
  const percentageWidth = percentage < 0 ? 0 : percentage;

  return (
    <>
      <div
        className={background(
          `${backgroundColorTailwind} rounded-full overflow-hidden ${
            borderColorTailwind ? `border border-${borderColorTailwind}` : ''
          }`
        )}>
        {/* MEMO: 達成時の進捗率は一律100%に固定 */}
        {isAchieved ? (
          <div
            className={''}
            style={{
              width: '100%',
              backgroundImage:
                'linear-gradient(90deg, #FFCB49 24.03%, #F97316 105.15%, #E2E8F0 105.16%)',
            }}>
            <div
              className={`${
                isShowPercentageStr ? 'text-white' : 'text-transparent'
              } flex flex-row items-baseline`}>
              <div className={percentageStr(`font-bold ml-2 text-sm`)}>100</div>
              <div className={`${percentageUnitStr(`text-xs font-bold`)}`}>
                %
              </div>
            </div>
          </div>
        ) : (
          <div
            className={foreground(`${foregroundColorTailwind}`)}
            style={{ width: `${percentageWidth}%` }}>
            <div
              className={`${
                isShowPercentageStr ? 'text-white' : 'text-transparent'
              } flex flex-row items-baseline`}>
              <div className={percentageStr(`font-bold ml-2 text-sm`)}>
                {Math.floor(percentage) < 0 ? 0 : Math.floor(percentage)}
              </div>
              <div className={`${percentageUnitStr(`text-xs font-bold`)}`}>
                %
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
